"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetRestaurantMenu = void 0;
var react_query_1 = require("@tanstack/react-query");
var api_1 = require("../../../store/api");
var store_1 = require("../../../store/store");
var useClear_1 = require("../../../hooks/useClear");
var useGetRestaurantMenu = function (_a) {
    var id = _a.id, type = _a.type, options = _a.options;
    (0, useClear_1.useClear)({ id: id });
    return (0, react_query_1.useQuery)(['restaurant-menu', id, type], function () { return (0, api_1.loadRestaurantMenu)(id, type); }, __assign(__assign({}, options), { onError: function () {
            store_1.history.push({ pathname: "/store" });
        } }));
};
exports.useGetRestaurantMenu = useGetRestaurantMenu;
